<!-- eslint-disable max-len, no-multiple-empty-lines -->
<template>
  <header>
    <div class="container">
      <div class="row">
        <a
          id="wsnavtoggle"
          class="wsanimated-arrow"
        ><span /></a>
        <div class="logo">
          <a :href="$t('wwwBaseUrl')"><img
            :src="`${$t('wwwBaseUrl')}/img/CoActiveCare_logo.svg`"
            alt="Georgian House"
          ></a>
        </div>
        <div class="head-phone">
          <img
            :src="`${$t('wwwBaseUrl')}/img/phone.svg`"
            alt="Phone Us"
          >
          <div class="text">
            <p><strong>General Enquiries: </strong><br>01803 201598</p>
            <p><strong>To make a referral: </strong><br> 01803 201598</p>
          </div>
        </div>
        <div class="head-right">
          <div class="head-top">
            <ul class="sub">
              <li><a :href="`${$t('wwwBaseUrl')}/feedback`">Feedback </a></li>
              <li><a :href="`${$t('wwwBaseUrl')}/contact`">Contact</a></li>
              <li><a :href="`${$t('wwwBaseUrl')}/referrals`">Referrals </a></li>
              <li>
                <a
                  :href="`${$t('wwwBaseUrl')}/make-an-enquiry`"
                  class="btn btn-primary"
                >Make an enquiry</a>
              </li>
            </ul>

            <ul class="social">
              <li>
                <a
                  href="https://twitter.com/House_georgian"
                  target="_blank"
                >
                  <img
                    :src="`${$t('wwwBaseUrl')}/img/twitter.svg`"
                    alt="Twitter"
                  ></a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com/georgian.house.311"
                  target="_blank"
                >
                  <img
                    :src="`${$t('wwwBaseUrl')}/img/facebook.svg`"
                    alt="Facebook"
                  ></a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/georgian-house-torquay-ltd/?viewAsMember=true"
                  target="_blank"
                >
                  <img
                    :src="`${$t('wwwBaseUrl')}/img/linkedin.svg`"
                    alt="Linkedin"
                  ></a>
              </li>
            </ul>
          </div>
          <!--Main Menu HTML Code-->
          <div class="wsmainfull clearfix">
            <div class="wsmainwp clearfix">
              <nav class="wsmenu clearfix">
                <div class="overlapblackbg">
                  <span />
                </div>
                <ul class="wsmenu-list">
                  <li><a :href="$t('wwwBaseUrl')">Home</a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/locations`">Locations</a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/specialisms`">Specialisms</a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/join-our-team`">Join our Team </a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/about`">About us</a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/blog`">News</a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/feedback`">Feedback</a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/contact`">Contact</a></li>
                  <li><a :href="`${$t('wwwBaseUrl')}/referrals`">Referrals</a></li>
                  <li class="bottom">
                    <a
                      :href="`${$t('wwwBaseUrl')}/make-an-enquiry`"
                      class="btn btn-primary"
                    >Make an enquiry</a>
                    <ul class="social">
                      <li>
                        <a
                          href="https://twitter.com/House_georgian"
                          target="_blank"
                        ><img
                          :src="`${$t('wwwBaseUrl')}/img/twitter.svg`"
                          alt="Twitter"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.facebook.com/georgian.house.311"
                          target="_blank"
                        ><img
                          :src="`${$t('wwwBaseUrl')}/img/facebook.svg`"
                          alt="Facebook"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.linkedin.com/company/georgian-house-torquay-ltd/?viewAsMember=true`"
                          target="_blank"
                        ><img
                          :src="`${$t('wwwBaseUrl')}/img/linkedin.svg`"
                          alt="Linkedin"
                        ></a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <!--Main Menu HTML Code-->
        </div>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  components: {
  },
  computed: {
  },
  created() {
  },
  methods: {
  },
};
</script>

<style scoped>
/* our CSS is at the very end of this scoped style*/

/*

--- webslide menu ----

/* ================== Desktop Base CSS  ================== */
.wsmenu html,
.wsmenu body,
.wsmenu iframe,
.wsmenu h1,
.wsmenu h2,
.wsmenu h3,
.wsmenu h4,
.wsmenu h5,
.wsmenu h6 {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  font-family: Helvetica, sans-serif;
  -webkit-font-smoothing: subpixel-antialiased;
  font-smoothing: antialiased;
  font-smooth: antialiased;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: subpixel-antialiased;
  font-smoothing: subpixel-antialiased;
  font-smooth: subpixel-antialiased;
}

.wsmenu .cl {
  clear: both;
}

.wsmenu img,
object,
embed,
video {
  border: 0 none;
  max-width: 100%;
}

.wsmenu a:focus {
  outline: none;
}

.wsmenu:before,
.wsmenu:after {
  content: "";
  display: table;
}

.wsmenu:after {
  clear: both;
}

/* ================== Desktop Main Menu CSS ================== */
.wsmenucontainer {
  background-size: cover;
  overflow: hidden;
  background-attachment: fixed;
  background-position: 50% 0;
  background-repeat: no-repeat;
}

.wsmainfull {
  width: 100%;
  height: 70px;
  position: relative;
}

.wsmainwp {
  margin: 0 auto;
  max-width: 1140px;
}

.desktoplogo {
  padding: 16px 0px 0px 0px;
  margin: 0;
  float: left;
}

.desktoplogo img {
  width: 100%
}

.wsmenu {
  font-family: Helvetica, sans-serif;
  color: #fff;
  font-size: 14px;
  padding: 0;
  width: 81%;
  float: right;
  display: block;
}

.wsmenu>.wsmenu-list {
  text-align: left;
  margin: 0 auto 0 auto;
  width: 100%;
  display: block;
  padding: 0;
}

.wsmenu>.wsmenu-list>li {
  text-align: center;
  display: block;
  padding: 0;
  margin: 0;
  float: left;
}

.wsmenu>.wsmenu-list>li>a {
  display: block;
  padding: 10px 28px 10px 19px;
  line-height: 50px;
  text-decoration: none;
  position: relative;
}

.wsmenu>.wsmenu-list>li:last-child>a {
  border-right: 0px;
}

.wsmenu>.wsmenu-list>li a.menuhomeicon {
  padding-left: 25px;
  padding-right: 25px;
}

.wsmenu>.wsmenu-list>li>a i {
  display: inline-block;
  font-size: 14px;
  line-height: inherit;
  margin-right: 12px;
  vertical-align: top;
}

.wsmenu>.wsmenu-list>li>a.menuhomeicon i {
  margin-right: 0px;
  font-size: 15px;
}

.wsmenu>.wsmenu-list>li>a .wsarrow:after {
  border-left: 4px solid rgba(0, 0, 0, 0);
  border-right: 4px solid rgba(0, 0, 0, 0);
  border-top: 4px solid;
  content: "";
  float: right;
  right: 11px;
  height: 0;
  margin: 0 0 0 14px;
  position: absolute;
  text-align: right;
  top: 33px;
  width: 0;
}

/* Desktop Search Bar */
.wsmenu>.wsmenu-list>li.rightmenu {
  float: right;
}

.wsmenu>.wsmenu-list>li.rightmenu a {
  padding: 0px 30px 0px 20px;
  border-right: none;
}

.wsmenu>.wsmenu-list>li.rightmenu a i {
  font-size: 15px;
}

.wsmenu>.wsmenu-list>li.rightmenu {
  float: right;
}

.wsmenu>.wsmenu-list>li.rightmenu:before,
.wsmenu-list>li.rightmenu:after {
  content: "";
  display: table;
}

.wsmenu>.wsmenu-list>li.rightmenu:after {
  clear: both;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch {
  float: right;
  width: 210px;
  height: 39px;
  position: relative;
  margin: 16px 0px 0px 0px;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch .searchicon {
  -webkit-transition: all 0.7s ease 0s;
  -moz-transition: all 0.7s ease 0s;
  -o-transition: all 0.7s ease 0s;
  transition: all 0.7s ease 0s;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch input {
  width: 100%;
  position: relative;
  float: right;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  text-indent: 15px;
  height: 39px;
  z-index: 2;
  outline: none;
  color: #333;
  background-color: #efefef;
  -webkit-transition: all 0.7s ease 0s;
  -moz-transition: all 0.7s ease 0s;
  -o-transition: all 0.7s ease 0s;
  transition: all 0.7s ease 0s;
  font-size: 12px;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch input::placeholder {
  color: #a9a9a9;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch input:focus {
  color: #333;
  width: 230px;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch input:focus~.btnstyle i {
  color: #000;
  opacity: 1;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch input:focus~.searchicon {
  opacity: 1;
  z-index: 3;
  color: #FFFFFF;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch .btnstyle {
  top: 0px;
  position: absolute;
  right: 0;
  bottom: 0;
  width: 40px;
  line-height: 30px;
  z-index: 1;
  cursor: pointer;
  opacity: 0.3;
  color: #333;
  z-index: 1000;
  background-color: transparent;
  border: solid 0px;
  -webkit-transition: all 0.7s ease 0s;
  -moz-transition: all 0.7s ease 0s;
  -o-transition: all 0.7s ease 0s;
  transition: all 0.7s ease 0s;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch .btnstyle i {
  line-height: 37px;
  margin: 0;
  padding: 0;
  text-align: center;
}

.wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch .btnstyle:hover i {
  opacity: 1;
}

.wsmenu>.wsmenu-list>li.rightmenu {
  zoom: 1;
}

/* ================== Desktop Drop Down Menu CSS ================== */
.wsmenu>.wsmenu-list>li>ul.sub-menu {
  position: absolute;
  top: 70px;
  z-index: 1000;
  margin: 0px;
  padding: 0px;
  min-width: 190px;
  background-color: #fff;
  border: solid 1px #eeeeee;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li {
  position: relative;
  margin: 0px;
  padding: 0px;
  display: block;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>a {
  background-image: none;
  color: #666666;
  border-right: 0 none;
  text-align: left;
  display: block;
  line-height: 22px;
  padding: 8px 12px;
  text-transform: none;
  font-size: 13px;
  letter-spacing: normal;
  border-right: 0px solid;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>a:hover {
  text-decoration: none;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>a>i {
  margin-right: 9px;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu {
  min-width: 220px;
  position: absolute;
  left: 100%;
  top: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  background-color: #fff;
  border: solid 1px #eeeeee;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li {
  position: relative;
  margin: 0px;
  padding: 0px;
  display: block;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>a {
  background-image: none;
  color: #666666;
  border-right: 0 none;
  text-align: left;
  display: block;
  line-height: 22px;
  padding: 8px 12px;
  text-transform: none;
  font-size: 13px;
  letter-spacing: normal;
  border-right: 0px solid;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>a:hover {
  text-decoration: none;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>a>i {
  margin-right: 9px;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu {
  min-width: 220px;
  position: absolute;
  left: 100%;
  top: 0;
  margin: 0px;
  list-style: none;
  padding: 0px;
  background-color: #fff;
  border: solid 1px #eeeeee;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li {
  position: relative;
  margin: 0px;
  padding: 0px;
  display: block;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a {
  background-image: none;
  color: #666666;
  border-right: 0 none;
  text-align: left;
  display: block;
  line-height: 22px;
  padding: 8px 12px;
  text-transform: none;
  font-size: 13px;
  letter-spacing: normal;
  border-right: 0px solid;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a:hover {
  text-decoration: none;
}

.wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a>i {
  margin-right: 9px;
}

/* ================== Desktop Mega Menus CSS  ================== */
.wsmenu>.wsmenu-list>li>.wsmegamenu {
  width: 100%;
  left: 0px;
  position: absolute;
  top: 70px;
  color: #000;
  z-index: 1000;
  margin: 0px;
  text-align: left;
  padding: 14px 5px;
  font-size: 15px;
  border: solid 1px #eeeeee;
  background-color: #fff;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .title {
  border-bottom: 1px solid #CCC;
  font-size: 14px;
  padding: 9px 5px 2px 0px;
  font-size: 17px;
  color: #424242;
  margin: 0px 0px 12px 0px;
  text-align: left;
  height: 39px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .wsmwnutxt {
  width: 100%;
  font-size: 14px;
  text-align: justify;
  line-height: 22px;
  color: #424242;
  margin-top: 10px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .link-list li {
  display: block;
  text-align: center;
  white-space: nowrap;
  text-align: left;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .link-list li a {
  line-height: 18px;
  border-right: none;
  text-align: left;
  padding: 6px 0px;
  background: #fff;
  background-image: none;
  color: #666666;
  border-right: 0 none;
  display: block;
  background-color: #fff;
  color: #424242;
  font-size: 13px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu li i {
  margin-right: 5px;
  text-align: center;
  width: 18px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu li a:hover {
  background: transparent;
  text-decoration: underline;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .link-list li i {
  font-size: 12px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu li i {
  margin-right: 5px;
  text-align: center;
  width: 18px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .mrgtop {
  margin-top: 15px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .show-grid div {
  padding-bottom: 10px;
  padding-top: 10px;
  background-color: #dbdbdb;
  border: 1px solid #e7e7e7;
  color: #6a6a6a;
  margin: 2px 0px;
  font-size: 13px;
}

/*= Desktop Half Menu CSS =*/
.wsmenu>.wsmenu-list>li>.wsmegamenu.halfmenu {
  width: 30%;
  right: auto;
  left: auto;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu.halfdiv {
  width: 20%;
  right: auto;
  left: auto;
}

/*= Desktop HTML Form Menu CSS =*/
.wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form {
  width: 100%;
  display: block;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form input[type="text"] {
  width: 100%;
  border: 1px solid #e2e2e2;
  color: #000;
  font-size: 13px;
  padding: 8px 5px;
  margin-bottom: 8px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form textarea {
  width: 100%;
  border: 1px solid #e2e2e2;
  color: #000;
  font-size: 13px;
  padding: 8px 5px;
  margin-bottom: 8px;
  min-height: 122px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form input[type="submit"] {
  width: 25%;
  display: block;
  height: 32px;
  float: right;
  border: none;
  margin-right: 15px;
  cursor: pointer;
  background-color: #e1e1e1;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form input[type="button"] {
  width: 25%;
  display: block;
  height: 32px;
  float: right;
  border: none;
  cursor: pointer;
  background-color: #e1e1e1;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  border-radius: 2px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .carousel-inner .item img {
  width: 100%;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .carousel-control-next {
  opacity: 0.8;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .carousel-control-prev {
  opacity: 0.8;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .carousel-caption {
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 13px;
  height: 31px;
  left: 0;
  padding: 7px 0;
  right: 0;
  width: 100%;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .typography-text {
  padding: 0px 0px;
  font-size: 14px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .typography-text ul {
  padding: 0px 0px;
  margin: 0px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .typography-text p {
  text-align: justify;
  line-height: 24px;
  color: #656565;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .typography-text ul li {
  display: block;
  padding: 2px 0px;
  line-height: 22px;
}

.wsmenu>.wsmenu-list>li>.wsmegamenu .typography-text ul li a {
  color: #656565;
}

/* ================== Desktop Extra CSS ================== */
.wsmobileheader {
  display: none;
}

.overlapblackbg {
  opacity: 0;
  visibility: hidden;
}

.wsmenu .wsmenu-click {
  display: none;
}

.wsmenu .wsmenu-click02 {
  display: none;
}

.hometext {
  display: none;
}

/*==============================================================================
                              Start Mobile CSS
===============================================================================*/
/* ================== Mobile Menu Change Brake Point ================== */
@media only screen and (max-width: 1200px) {

  /* ================== Mobile Base CSS ================== */
  html {
    /*overflow: hidden;*/
    /*height: 100%;*/
    -webkit-overflow-scrolling: touch;
  }

  body {
    /*height: 100%;*/
    /*overflow-y: auto;*/
    /*overflow-x: hidden;*/
  }

  body.wsactive {
    overflow: hidden;
  }

  /* ================== Mobile Main Menu CSS ================== */
  .desktoplogo {
    display: none;
  }

  .wsmainfull {
    height: 0;
  }

  .wsmenucontainer {
    background-attachment: local;
    background-position: 33% 0%;
  }

  .wsmenu {
    width: 100%;
    background: rgba(0, 0, 0, 0) none repeat scroll 0 0;
    left: 0;
    overflow-y: hidden;
    padding: 0;
    top: 0;
    visibility: hidden;
    position: fixed;
    margin: 0px;
  }

  .wsmenu>.wsmenu-list {
    height: auto;
    min-height: 100%;
    width: 240px;
    background: #fff;
    padding-bottom: 0;
    margin-left: -240px;
    display: block;
    text-align: center;
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
  }

  .wsmenu>.wsmenu-list li {
    width: 100%;
    display: block;
    float: none;
    border-right: none;
    background-color: transparent;
    position: relative;
    white-space: inherit;
    clear: right;
  }

  @supports (-webkit-overflow-scrolling: touch) {
    .wsmenu>.wsmenu-list>li:last-child {
      padding-bottom: 110px;
    }
  }

  .wsmenu>.wsmenu-list li a {
    padding: 12px 32px 12px 17px;
    font-size: 14px;
    text-align: left;
    border-right: solid 0px;
    background-color: transparent;
    color: #666666;
    line-height: 25px;
    border-bottom: 1px solid;
    border-bottom-color: rgba(0, 0, 0, 0.13);
    position: static;
  }

  .wsmenu>.wsmenu-list>li a.menuhomeicon {
    padding-left: 17px;
    padding-right: 17px;
    border-top: solid 1px rgba(0, 0, 0, 0.13);
  }

  .wsmenu>.wsmenu-list>li>a.menuhomeicon i {
    display: none;
  }

  .wsmenu>.wsmenu-list>li>a>i {
    font-size: 16px;
    color: #bfbfbf;
  }

  .wsmenu>.wsmenu-list>li>a .wsarrow:after {
    display: none;
  }

  .wsmenu>.wsmenu-list>li:hover>a {
    background-color: rgba(0, 0, 0, 0.08);
    text-decoration: none;
  }

  .wsmenu>.wsmenu-list>li>a>.hometext {
    display: inline-block;
  }

  /* ================== Mobile Slide Down Links CSS ================== */
  .wsmenu>.wsmenu-list>li>ul.sub-menu {
    display: none;
    position: relative;
    top: 0px;
    background-color: #fff;
    border: none;
    padding: 0px;
    opacity: 1;
    visibility: visible;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    transform: none;
    -webkit-transition: inherit;
    -moz-transition: inherit;
    transition: inherit;
    -webkit-transform-style: flat;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>a {
    line-height: 20px;
    font-size: 13px;
    padding: 10px 0px 10px 16px;
    color: #383838;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li span+a {
    padding-right: 30px;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>a>i {
    display: none;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>a:hover {
    background-color: #e7e7e7;
    color: #666666;
    text-decoration: underline;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu li:hover>a {
    background-color: #e7e7e7;
    color: #666666;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu {
    width: 100%;
    position: static;
    left: 100%;
    top: 0;
    display: none;
    margin: 0px;
    padding: 0px;
    border: solid 0px;
    transform: none;
    opacity: 1;
    visibility: visible;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    transform: none;
    -webkit-transition: inherit;
    -moz-transition: inherit;
    transition: inherit;
    -webkit-transform-style: flat;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li {
    margin: 0px 0px 0px 0px;
    padding: 0px;
    position: relative;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>a {
    line-height: 20px;
    font-size: 13px;
    padding: 10px 0px 10px 26px;
    color: #383838;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li span+a {
    padding-right: 30px;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>a>i {
    display: none;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>a:hover {
    background-color: #e7e7e7;
    color: #666666;
    text-decoration: underline;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>a.active {
    color: #000;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li:hover>a {
    color: #000;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu {
    width: 100%;
    position: static;
    left: 100%;
    top: 0;
    display: none;
    margin: 0px;
    padding: 0px;
    border: solid 0px;
    transform: none;
    opacity: 1;
    visibility: visible;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    transform: none;
    -webkit-transition: inherit;
    -moz-transition: inherit;
    transition: inherit;
    -webkit-transform-style: flat;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li {
    margin: 0px 0px 0px 0px;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a {
    line-height: 20px;
    font-size: 13px;
    padding: 10px 0px 10px 34px;
    color: #383838;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li span+a {
    padding-right: 30px;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a>i {
    display: none;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a:hover {
    background-color: #e7e7e7;
    color: #666666;
    text-decoration: underline;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li>ul.sub-menu>li>ul.sub-menu>li>a.active {
    color: #000;
  }

  /* ================== Mobile Mega Menus CSS  ================== */
  .wsmenu>.wsmenu-list>li>.wsmegamenu {
    color: #666666;
    display: none;
    position: relative;
    top: 0px;
    padding: 10px 0px;
    border: solid 0px;
    transform: none;
    opacity: 1;
    visibility: visible;
    -webkit-transform: none;
    -moz-transform: none;
    -ms-transform: none;
    -o-transform: none;
    transform: none;
    -webkit-transition: inherit;
    -moz-transition: inherit;
    transition: inherit;
    border-bottom: 1px solid rgba(0, 0, 0, 0.13);
    -webkit-transform-style: flat;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu.halfmenu {
    width: 100%;
    margin: 0px;
    padding: 5px 0px 10px 0px;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu .title {
    color: #666666;
    font-size: 15px;
    padding: 10px 8px 10px 0px;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu>ul {
    width: 100%;
    margin: 0px;
    padding: 0px;
    font-size: 13px;
  }

  /*.wsmenu>.wsmenu-list>li>.wsmegamenu>ul>li>a {
    padding: 9px 14px;
    line-height: normal;
    font-size: 13px;
    background-color: #e7e7e7;
    color: #666666;
  }*/

  .wsmenu>.wsmenu-list>li>.wsmegamenu>ul>li>a:hover {
    background-color: #000000;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu ul li.title {
    line-height: 26px;
    color: #666666;
    margin: 0px;
    font-size: 15px;
    padding: 7px 0px;
    background-color: transparent;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu.halfdiv {
    width: 100%;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form {
    padding: 5px 0px 62px 0px;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu .show-grid div {
    margin: 0px;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form input[type="button"] {
    width: 46%;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form input[type="submit"] {
    width: 46%;
  }

  .wsmenu>.wsmenu-list>li>.wsmegamenu .menu_form textarea {
    min-height: 100px;
  }

  /* ================== Mobile Header CSS ================== */
  .wsmobileheader {
    width: 100%;
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10002;
    height: 54px;
    background-color: #eaecf0;
    text-align: center;
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    box-shadow: 0 0 1px rgba(0, 0, 0, .3);
  }

  .wsactive .wsmobileheader {
    margin-left: 240px;
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
  }

  .wsmobileheader .smllogo {
    display: inline-block;
    margin-top: 12px;
  }

  /* Mobile Search Bar*/
  .wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch {
    width: 86%;
    margin: 7% 7%;
    padding: 0px;
  }

  .wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch input {
    border-radius: 50px
  }

  .wsmenu>.wsmenu-list>li.rightmenu>.topmenusearch input:focus {
    width: 100%;
  }

  .callusbtn {
    color: #a9a9a9;
    font-size: 17px;
    position: absolute;
    right: 5px;
    top: 0px;
    transition: all 0.4s ease-in-out 0s;
    z-index: 102;
    padding: 13px 14px;
  }

  .callusbtn i {
    vertical-align: top;
    margin-top: 4px;
  }

  .callusbtn:hover i {
    color: #a9a9a9;
  }

  /* Mobile Toggle Menu icon (X ICON) */
  .wsanimated-arrow {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 102;
    -webkit-transition: all 0.4s ease-in-out;
    -moz-transition: all 0.4s ease-in-out;
    -o-transition: all 0.4s ease-in-out;
    -ms-transition: all 0.4s ease-in-out;
    transition: all 0.4s ease-in-out;
  }

  .wsanimated-arrow {
    cursor: pointer;
    padding: 16px 35px 16px 0px;
    margin: 7px 0 0 15px;
  }

  .wsanimated-arrow span,
  .wsanimated-arrow span:before,
  .wsanimated-arrow span:after {
    cursor: pointer;
    height: 2px;
    width: 17px;
    background: #a9a9a9;
    position: absolute;
    display: block;
    content: '';
  }

  .wsanimated-arrow span:before {
    top: -7px;
    width: 23px;
  }

  .wsanimated-arrow span:after {
    bottom: -7px;
    width: 17px;
  }

  .wsanimated-arrow span,
  .wsanimated-arrow span:before,
  .wsanimated-arrow span:after {
    transition: all 500ms ease-in-out;
  }

  .wsactive .wsanimated-arrow span:after {
    width: 23px;
  }

  .wsactive .wsanimated-arrow span {
    background-color: transparent;
  }

  .wsactive .wsanimated-arrow span:before,
  .wsactive .wsanimated-arrow.active span:after {
    top: 7px;
  }

  .wsactive .wsanimated-arrow span:before {
    transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    bottom: 0px;
  }

  .wsactive .wsanimated-arrow span:after {
    transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  /* ================== Mobile Overlay/Drawer CSS ================== */
  .overlapblackbg {
    right: 0;
    width: calc(100% - 240px);
    height: 100vh;
    min-height: 100%;
    position: fixed;
    top: 0;
    opacity: 0;
    visibility: hidden;
    background-color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
  }

  .wsactive .wsmenu .overlapblackbg {
    opacity: 1;
    visibility: visible;
    -webkit-transition: opacity 1.5s ease-in-out;
    -moz-transition: opacity 1.5s ease-in-out;
    -ms-transition: opacity 1.5s ease-in-out;
    -o-transition: opacity 1.5s ease-in-out;
  }

  .wsmenucontainer {
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
  }

  .wsactive .wsmenucontainer {
    margin-left: 240px;
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
  }

  .wsactive .wsmenu {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    visibility: visible;
    z-index: 1000;
    top: 0;
  }

  .wsactive .wsmenu>.wsmenu-list {
    -webkit-transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
    -ms-transition: all 0.25s ease-in-out;
    transition: all 0.25s ease-in-out;
    margin-left: 0;
  }

  /* ================== Mobile Sub Menu Expander Arrows  ================== */
  .wsmenu>.wsmenu-list>li .wsmenu-click, .wsmenu>.wsmenu-list>li .wsmenu-click02 {
    height: 49px;
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    cursor: pointer;
    width: 100%;
  }

  .wsmenu>.wsmenu-list>li .wsmenu-click.ws-activearrow>i,
  .wsmenu>.wsmenu-list>li .wsmenu-click02.ws-activearrow>i {
    transform: rotate(-45deg);
    margin-top: 23px;
  }

  .wsmenu>.wsmenu-list>li>.wsmenu-click>i,.wsmenu>.wsmenu-list>li .wsmenu-click02>i {
    display: block;
    height: 8px;
    width: 8px;
    float: right;
    transform: rotate(-225deg);
    margin: 18px 18px 0px 0px;
  }

  .wsmenu>.wsmenu-list>li>.wsmenu-click>i:before, .wsmenu>.wsmenu-list>li .wsmenu-click02>i:before {
    content: "";
    width: 100%;
    height: 100%;
    border-width: 1.5px 1.5px 0 0;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.40);
    transition: 0.2s ease;
    display: block;
    transform-origin: 100% 0;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li .wsmenu-click02 {
    height: 41px;
    position: absolute;
    top: 0;
    right: 0;
    display: block;
    cursor: pointer;
    width: 100%;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li .wsmenu-click02>i {
    display: block;
    height: 8px;
    width: 8px;
    float: right;
    transform: rotate(-225deg);
    margin: 14px 18px 0px 0px;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li .wsmenu-click02>i:before {
    content: "";
    width: 100%;
    height: 100%;
    border-width: 1.5px 1.5px 0 0;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.40);
    transition: 0.2s ease;
    display: block;
    transform-origin: 100% 0;
  }

  .wsmenu>.wsmenu-list>li>ul.sub-menu>li .wsmenu-click02>i.wsmenu-rotate {
    transform: rotate(-45deg);
    margin-top: 19px;
  }

  /*End Media Query*/
}

header {
 position:relative;
 width:100%;
 background:#fff;
 width:100%;
 top:0;
 left:0;
 border-bottom:5px solid #FFCC00;
 z-index:100;
 padding:10px 0 12px
}
.social img {
  width:25px;
  height:25px
 }
.btn,
.is-btn {
 border-radius:30px;
 border:none;
 -webkit-box-shadow:none;
 box-shadow:none;
 text-transform:uppercase;
 padding:6px 20px;
 display:inline-block;
 -webkit-transition:all 0.3s ease 0s;
 -o-transition:all 0.3s ease 0s;
 transition:all 0.3s ease 0s;
 margin:0;
 text-align:center
}
.btn:hover,
.is-btn:hover {
 -webkit-box-shadow:0 0 5px 3px rgba(0, 0, 0, 0.05);
 box-shadow:0 0 5px 3px rgba(0, 0, 0, 0.05)
}
.btn-primary,
.is-btn {
 background:#667A00;
 color:#fff
}
.btn-white {
 background:#fff;
 color:#333
}
.btn-yborder {
 border:1px solid #FFCC00;
 color:#FFCC00
}
.btn-whiteb {
 border:1px solid #fff
}
.btn-grey,
.btn-secondary {
 background:#9B9B9B!important;
 color:#fff
}
.btn-grey:hover,
.btn-primary:hover,
.btn-secondary:hover,
.btn-white:hover,
.btn-whiteb:hover,
.btn-yborder:hover,
.is-btn:hover {
 background:#FFCC00!important;
 color:#000;
 border-color:#FFCC00!important
}
.wsmenu {
 font-family:"Work Sans", sans-serif
}
@media (min-width:1000px) {
 .container {
  max-width:1018px
 }
}
@media (min-width:1200px) {
 .container {
  max-width:1018px
 }
 header .logo img {
  width:200px
 }
 header .head-phone {
  display:inline-block;
  width:279px;
  font-size:14px;
  color:#575756
 }
 header .head-phone img {
  width:43px
 }
 header .head-phone .text {
  width:calc(100% - 50px);
  display:inline-block;
  vertical-align:middle;
  line-height:1;
  padding-left:5px
 }
 header .head-phone .text p {
  margin:0
 }
 header .head-phone .text p:first-child {
  margin-bottom:5px
 }
 header .container {
  position:relative
 }
 .logo {
  padding:0 40px 0 0
 }
 .head-right {
  text-align:right;
  -ms-flex-preferred-size:1;
  flex-basis:1;
  -webkit-box-flex:0;
  -ms-flex-positive:0;
  flex-grow:0;
  -ms-flex:1;
  flex:1;
  font-size:14px
 }
 .head-right .btn {
  font-size:12px;
  font-weight:600
 }
 .wsmainfull {
  width:auto;
  height:auto;
  position:absolute;
  right:0;
  top:33px
 }
 .wsmenu {
  width:auto
 }
 .wsmenu>.wsmenu-list>li {
  float:none;
  display:inline-block
 }
 .wsmenu>.wsmenu-list>li:nth-child(7),
 .wsmenu>.wsmenu-list>li:nth-child(8),
 .wsmenu>.wsmenu-list>li:nth-child(9),
 .wsmenu>.wsmenu-list>li:nth-child(10) {
  display:none
 }
 .wsmenu>.wsmenu-list>li>a {
  line-height:inherit;
  font-weight:600;
  font-size:16px;
  padding:0 8px;
  color:#333;
  line-height:55px
 }
 .wsmenu>.wsmenu-list>li.active>a {
  color:#839D00
 }
 .wsmenu>.wsmenu-list>li:first-child>a {
  padding-left:0
 }
 .wsmenu>.wsmenu-list>li:nth-child(6)>a {
  padding-right:0
 }
 .head-top ul {
  list-style:none;
  padding:0;
  margin:0
 }
 .head-top ul li {
  display:inline-block
 }
 .head-top {
  border-bottom:1px solid #ECECEC;
  padding-bottom:10px;
  padding-right:28px
 }
 .head-top .sub a:not(.btn) {
  color:#575756;
  padding-right:15px
 }
 .sub {
  display:inline-block
 }
 .social {
  display:inline-block
 }
 .social a {
  display:block;
  margin:0 2px
 }
 .social img {
  width:25px;
  height:25px;
 }
 .head-top .sub a:not(.btn):hover,
 .wsmenu>.wsmenu-list>li>a:hover {
  color:#839D00
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu {
  top:52px;
  width:auto;
  left:auto;
  border:none;
  padding:10px 20px;
  -webkit-transform:none!important;
  -ms-transform:none!important;
  transform:none!important
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu ul {
  list-style:none;
  margin:0;
  padding:0
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu ul li a {
  color:#333;
  -webkit-transition:none;
  -o-transition:none;
  transition:none
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu ul li a:hover {
  color:#839D00;
  text-decoration:none
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu ul li {
  border-bottom:1px solid #ECECEC;
  padding:5px 0
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu ul li:last-child {
  border:none
 }
 #mcontact {
  display:none!important
 }
 .wsmainfull .bottom {
  display:none!important
 }
 .wsmenu .mob {
  display:none
 }
}
@media (max-width:1199px) {
 header {
  height:70px;
  padding:7px 0
 }
 .head-phone {
  display:none
 }
 .head-top .social,
 .head-top .sub {
  display:none
 }
 header .logo {
  width:150px;
  height:51px;
  margin:auto
 }
 header .container {
  position:relative
 }
 .wsanimated-arrow {
  margin-top:17px;
  position:fixed;
  z-index:100
 }
 .wsanimated-arrow span,
 .wsanimated-arrow span:after,
 .wsanimated-arrow span:before {
  width:23px;
  background-color:#839D00
 }
 .search-bar__submit img {
  width:22px;
  height:22px
 }
 .search-bar__submit {
  height:35px;
  width:35px
 }
 .search-bar {
  width:40px;
  height:40px;
  border-radius:0
 }
 .search-bar__input {
  height:35px
 }
 #search {
  top:9.5px;
  z-index:103
 }
 .search-bar:focus-within {
  width:100vw;
  margin-top:50px
 }
 .search-bar:focus-within .search-bar__submit {
  margin-top:-3px;
  margin-right:-3px;
  position:absolute;
  right:5px
 }
 .search-bar:focus-within .search-bar__input {
  width:100%
 }
 #maincontent {
  margin-top:70px
 }
 #mcontact {
  background:#000;
  text-align:center;
  text-transform:uppercase;
  font-size:12px;
  padding:15px;
  width:100%;
  left:0;
  bottom:0;
  z-index:10;
  position:fixed
 }
 #mcontact a {
  color:#fff;
  display:inline-block;
  text-align:center;
  margin:0 30px
 }
 #mcontact a:first-child img {
  width:25px;
  height:17px
 }
 #mcontact a:last-child img {
  width:15px;
  height:24px
 }
 #mcontact img {
  display:block;
  margin:0 auto 5px
 }
 .wsactive .wsmenucontainer {
  margin-left:0
 }
 .wsmenu>.wsmenu-list {
  padding-top:60px;
  width:100%
 }
 .wsmenu>.wsmenu-list li a {
  font-size:20px;
  color:#000;
  font-weight:600
 }
 .wsmenu>.wsmenu-list li a {
  border-bottom:1px solid #ECECEC
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu>ul>li>a:hover {
  background:transparent
 }
 .wsmenu>.wsmenu-list li a {
  display:block
 }
 .wsmenu>.wsmenu-list>li:hover>a {
  background:#ECECEC
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu li a:hover {
  text-decoration:none
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu {
  border:none;
  padding:0
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu>ul>li>a {
  padding-left:30px
 }
 .wsmenu>.wsmenu-list>li .wsmenu-click02>i:before,
 .wsmenu>.wsmenu-list>li>.wsmenu-click>i:before {
  border-color:#9B9B9B
 }
 .overlapblackbg {
  cursor:pointer;
  padding:16px 35px 16px 0px;
  margin:17px 0 0 15px;
  z-index:100;
  position:absolute;
  left:0;
  top:0;
  z-index:102;
  width:auto;
  background:transparent;
  height:auto;
  opacity:1;
  min-height:0
 }
 .overlapblackbg span,
 .overlapblackbg span:after,
 .overlapblackbg span:before {
  cursor:pointer;
  height:2px;
  width:23px;
  background:#000000;
  position:absolute;
  display:block;
  content:''
 }
 .overlapblackbg span:before {
  top:-7px;
  width:23px
 }
 .overlapblackbg span:after {
  bottom:-7px;
  width:23px
 }
 .overlapblackbg span {
  background-color:transparent
 }
 .overlapblackbg span:after,
 .overlapblackbg span:before {
  top:7px
 }
 .overlapblackbg span:before {
  -webkit-transform:rotate(45deg);
  -ms-transform:rotate(45deg);
  transform:rotate(45deg);
  bottom:0px
 }
 .overlapblackbg span:after {
  -webkit-transform:rotate(-45deg);
  -ms-transform:rotate(-45deg);
  transform:rotate(-45deg)
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu {
  opacity:1
 }
 .wsmenu>.wsmenu-list .bottom {
  border:none;
  padding:50px 12px 20px
 }
 .wsmenu>.wsmenu-list .bottom .btn {
  border-radius:30px;
  border:none;
  -webkit-box-shadow:none;
  box-shadow:none;
  text-transform:uppercase;
  padding:7px 20px;
  background:#839D00;
  line-height:1;
  background-color:#839d00;
  color:#fff;
  font-size:12px;
  display:inline-block
 }
 .bottom .social {
  display:inline-block;
  width:calc(100% - 160px);
  text-align:right;
  padding:0
 }
 .bottom .social img {
  width:25px;
  height:25px
 }
 .wsmenu>.wsmenu-list li .social a {
  padding:0;
  border:none
 }
 .wsmenu>.wsmenu-list li .social li {
  display:inline-block;
  width:auto;
  margin-left:5px
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu {
  visibility:visible
 }
 .wsmenu>.wsmenu-list>li>.wsmegamenu {
  -webkit-transform:none;
  -ms-transform:none;
  transform:none
 }
 #topgrid .col-md-3 {
  height:calc(100vh - 145px)
 }
}
@media (max-width:991px) {
 #contentgrid .news-item .img {
  height:25vw
 }
 #contentgrid .news-item .wrap {
  height:calc(100% - 25vw)
 }
 #contentgrid .col-lg-4 {
  -webkit-box-orient:horizontal;
  -webkit-box-direction:normal;
  -ms-flex-direction:row;
  flex-direction:row;
  padding:0
 }
 #contentgrid .col-lg-4 .block-side {
  width:50%;
  display:inline-block;
  height:auto;
  margin:30px 15px 0
 }
 #contentgrid {
  margin:30px 0
 }
 #contentgrid .jteam h2 {
  margin-bottom:250px
 }
 .touch .col {
  -webkit-box-pack:center;
  -ms-flex-pack:center;
  justify-content:center
 }
 .touch .col h2 {
  margin-bottom:10px
 }
 .locgrid>div {
  margin-bottom:30px
 }
 .locgrid {
  margin-bottom:0
 }
 .intro br {
  display:none
 }
 .team figure {
  height:24vw
 }
 .team .name {
  height:calc(100% - 24vw)
 }
 .team>div:hover figure {
  height:calc(24vw + 20px)
 }
 .team>div:hover .name {
  height:calc((100% - 24vw) + 10px)
 }
 .team>div:hover .wrap {
  margin:-10px
 }
 .tmodal .modal-header .close {
  right:15px
 }
 .sidebar .inlineform #RecaptchaField0 {
  -webkit-transform:scale(0.65);
  -ms-transform:scale(0.65);
  transform:scale(0.65)
 }
 #cookies p {
  width:calc(100% - 250px)
 }
}
@media only screen and (max-width:960px) and (min-width:767px) {
 #specialisms-tabs .nav-tabs .nav-item {
  width:50%
 }
 #specialisms-tabs .nav-tabs .nav-link {
  height:100%
 }
}
@media (max-width:767px) {
 #topgrid .col-md-3 {
  border-bottom:3px solid
 }
 #topgrid .col-md-3:nth-child(3) {
  border-bottom:transparent
 }
 #topgrid .col-md-3:nth-child(2) {
  border-right:transparent
 }
 #twitter h2,
 .intro h1,
 .intro h2,
 .location .intro p,
 .news-item h2 {
  font-size:22px
 }
 .fullspec h2,
 .gallery-carousel h2,
 .location-carousel h2,
 .touch h2 {
  font-size:26px
 }
 .location-carousel .item {
  height:60vw
 }
 .gallery-carousel .item {
  height:60vw
 }
 .owl-prev {
  left:0
 }
 .owl-next {
  right:0
 }
 .owl-nav img {
  width:20px;
  height:20px
 }
 .touch p {
  font-size:18px;
  margin-top:10px
 }
 .touch .btn {
  padding:10px 30px
 }
 .touch .col {
  text-align:center;
  display:block
 }
 .fullspec li {
  font-size:18px
 }
 .fullspec {
  padding:50px 0
 }
 .fullspec .btn {
  padding:10px 30px;
  font-size:16px
 }
 #contentgrid #twitter>div {
  margin-top:0
 }
 #contentgrid .news-item {
  margin-bottom:30px;
  -webkit-box-flex:100%;
  -ms-flex:100%;
  flex:100%
 }
 .news-item .date {
  font-size:16px
 }
 footer .grey {
  padding:50px 0
 }
 footer .text {
  padding-right:0
 }
 footer .grey .row>div:nth-child(2) {
  padding-left:97px
 }
 footer .black p {
  display:block
 }
 footer .black p:last-child {
  float:none;
  margin-top:5px
 }
 #topgrid {
  padding:0
 }
 #topgrid .row {
  display:none
 }
 #topimg {
  height:200px
 }
 h1 {
  font-size:38px
 }
 .vside {
  position:-webkit-sticky;
  position:sticky;
  top:70px;
  padding:0;
  z-index:2;
  margin:-50px 0 30px
 }
 .vside .mfilter {
  border-radius:0;
  width:100%;
  font-weight:600
 }
 body:not(.home) #twitter h2 {
  margin-bottom:50px
 }
 #specialisms-tabs #content.tab-content>.tab-pane {
  display:block;
  opacity:1;
  padding:0 17px
 }
 #specialisms-tabs .nav-tabs {
  display:none
 }
 .sidebar.sticky {
  display:block
 }
 .location .sidebar {
  margin-bottom:30px
 }
}
@media (max-width:644px) {
 .fullspec li {
  display:block
 }
 .fullspec li:after {
  content:none
 }
}
@media (max-width:584px) {
 .touch .btn {
  margin:15px auto 0
 }
 .touch span,
 .touch strong {
  display:block
 }
}
@media (max-width:575px) {
 #contentgrid .news-item .img,
 body:not(.home) #news-tweet .news-item .img {
  height:50vw
 }
 #contentgrid .news-item .wrap,
 body:not(.home) #news-tweet .news-item .wrap {
  height:auto;
  padding:26px 26px 80px 26px
 }
 #contentgrid .col-lg-4 {
  display:block;
  padding:0 15px
 }
 #contentgrid .col-lg-4 .block-side {
  width:100%;
  margin:0
 }
 #contentgrid .col-lg-4 .block-side.jteam {
  margin-bottom:30px
 }
 footer img {
  width:40px;
  height:33px
 }
 footer .grey .row>div:nth-child(2),
 footer .grey .row>div:nth-child(3) {
  padding-left:70px;
  -webkit-box-flex:100%;
  -ms-flex:100%;
  flex:100%;
  max-width:100%
 }
 .team figure {
  height:70vw
 }
 .team>div:hover figure {
  height:calc(70vw + 20px)
 }
 .team .name {
  height:calc(100% - 70vw)
 }
 .team>div:hover .name {
  height:calc((100% - 70vw) + 10px)
 }
 .btn-row {
  display:block;
  margin:0
 }
 .btn-row>a {
  margin:15px 0;
  display:block
 }
 #scrollTop {
  width:35px;
  height:35px;
  background-size:15px
 }
 #cookies p {
  width:100%;
  margin-bottom:10px
 }
 #cookies .col {
  display:block
 }
 .cshow {
  padding-bottom:110px
 }
 .testimonial-carousel .test_content:after,
 .testimonial-carousel .test_content:before {
  background-size:25px
 }
 .testimonial-carousel .quote {
  padding:10px
 }
 .testimonial-carousel .test_content {
  padding:5px 10px
 }
 .testimonial-carousel .owl-prev {
  left:-15px
 }
 .testimonial-carousel .owl-next {
  right:-15px
 }
 #testside h2,
 .test-quote p:not(.from) {
  font-size:20px
 }
 .center-mob {
  text-align:center
 }
}
#career .padd10 {
 padding:10px!important
}
#career .nchanged {
 display:none
}
#career .detailsc {
 display:none
}
#career .dbschanged {
 display:none
}
#career #maincontent ul:not(.nav-tabs) li:before {
 content:none!important
}
#career #maincontent ul:not(.nav-tabs) li {
 text-indent:0
}
#career .cintro {
 background-color:#839c00;
 color:#fff;
 text-align:center;
 font-size:115%;
 padding:20px
}
#career .cintro a:link,
.cintro a:visited {
 color:#FFCC00
}
#career .cintro a:hover {
 color:#fff
}
#career .dllengthc {
 display:none
}
#career .dconvc {
 display:none
}
#career .dconvdesc {
 display:none
}
#career .hasError {
 border:solid 1px red
}
#career .customerror {
 color:red
}
#career .companynamec,
#career .positionc,
#career .refereec,
#career .refereeemail1c,
#career .refereetelc,
#career .roledescription1c {
 display:none
}
#career #maincontent ul:not(.nav-tabs) li {
 padding-left:10px
}
#career .cintro h2 {
 font-size:28px;
 font-weight:400
}
#career .ctintro b,
#career .ctintro strong {
 color:#FFCC00
}
#career .careerform li {
 margin-bottom:0!important
}
#career .formhead {
 color:#fff;
 padding:15px;
 background-color:#FFCC00;
 position:absolute;
 top:0;
 left:0;
 margin:0;
 width:100%
}
#career .formhead span {
 font-weight:400
}
#career .finner {
 padding:30px 20px 20px 20px;
 background-color:#fff;
 position:relative
}
#career .toppadd {
 padding-top:65px
}
#career .toppadd2 {
 padding-top:80px
}
#career .form-group {
 margin-bottom:3px
}
#career .focusbox {
 border:solid 2px #839D00;
 padding:50px 10px 10px 10px;
 margin:20px 0;
 position:relative;
 border-radius:15px;
 overflow:hidden;
 width:100%
}
#career .focustitle {
 background-color:#839D00;
 color:#fff;
 position:absolute;
 left:0;
 top:0;
 padding:5px 15px;
 width:100%
}
a {
  color:#667A00;
}
</style>
